import { Col, Divider, Row } from 'antd'
import { FC, ReactNode, useState } from 'react'

import { BitazzaModal, BitazzaText } from '../../../../../components'
import Styles from './StatisticRowBox.module.scss'
import { getColor } from '../../../../../util/getColor'

interface Props {
    label1: string
    value1: string | number
    label2?: string
    value2?: string | number
    value1NoFormat?: number
    value2NoFormat?: number
    icon?: ReactNode
    infoContent?: ReactNode
    size?: string
}
export const StatisticRowBox: FC<Props> = ({
    label1,
    value1,
    label2,
    value2,
    value1NoFormat,
    value2NoFormat,
    icon,
    infoContent,
    size,
}) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
    return (
        <div className={Styles.container}>
            <BitazzaModal
                size={size ? size : '500px'}
                footer={
                    <div
                        className={Styles.button}
                        onClick={() => setIsModalOpen(false)}
                    >
                        <BitazzaText
                            format="t18"
                            color="#FFF"
                            content="Close"
                            bold
                        />
                    </div>
                }
                onCancel={() => setIsModalOpen(false)}
                isModalOpen={isModalOpen}
            >
                {infoContent}
            </BitazzaModal>
            <Row justify="space-between">
                <Col>
                    <BitazzaText
                        content={label1}
                        format="t16"
                        color="#FFFFFF"
                    />
                    <span onClick={() => setIsModalOpen(true)}>{icon}</span>
                </Col>
                <Col>
                    <BitazzaText
                        content={value1}
                        format="t20"
                        color={
                            value1NoFormat
                                ? getColor(value1NoFormat)
                                : '#F1D87E'
                        }
                    />
                </Col>
            </Row>

            {label2 && (
                <>
                    <Divider className={Styles.divider} />
                    <Row justify="space-between">
                        <Col>
                            <BitazzaText
                                content={label2}
                                format="t16"
                                color="#FFFFFF"
                            />
                        </Col>

                        <Col>
                            {value2 && (
                                <BitazzaText
                                    content={value2}
                                    format="t20"
                                    color={
                                        value2NoFormat
                                            ? getColor(value2NoFormat)
                                            : '#F1D87E'
                                    }
                                />
                            )}
                        </Col>
                    </Row>
                </>
            )}
        </div>
    )
}
